const EMAIL_PATTERN = /^[^\s@,]+@[^\s@,]+\.[^\s@,]+$/;

export const statementRecipientEmails = (value = "") =>
  (Array.isArray(value) ? value : String(value || "").split(","))
    .map((email) => String(email || "").trim())
    .filter(Boolean);

export const normaliseStatementEmails = (value = "") => {
  const seen = new Set();
  return statementRecipientEmails(value)
    .filter((email) => {
      const key = email.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .join(", ");
};

export const isValidStatementEmails = (value = "") =>
  statementRecipientEmails(value).every((email) => EMAIL_PATTERN.test(email));

export const statementRecipientGroupIds = (value = "") =>
  statementRecipientEmails(value)
    .filter((recipient) => recipient.toLowerCase().startsWith("group:"))
    .map((recipient) => recipient.slice("group:".length).trim())
    .filter(Boolean);

export const resolveStatementRecipientEmails = (
  value = "",
  groupRecords = {},
  field = "emailCommissionStatementsTo",
) => normaliseStatementEmails(
  statementRecipientEmails(value).flatMap((recipient) => {
    if (!recipient.toLowerCase().startsWith("group:")) return recipient;
    const groupId = recipient.slice("group:".length).trim();
    return statementRecipientEmails(groupRecords[groupId]?.bankDetails?.[field]);
  }),
);

export const statementCcEmails = statementRecipientEmails;
export const normaliseStatementCc = normaliseStatementEmails;
export const isValidStatementCc = isValidStatementEmails;
